import React from 'react';
import styled from 'styled-components';

import { DesktopContainer } from 'components/atoms/Container';
import { Logo, LogoText } from 'components/atoms/Logo';
import { PrimaryButton } from 'components/molecules/Button';
import { Button } from 'shell/components';

const Desktop = ({ stepKeys, currentStep = 0, renderPage, review, canSubmit, handleClickNext }) => {
    return (
        <StyledDesktopContainer>
            <ScrollContainer>
                <DesktopCourseSetUpContainer>
                    <LogoContainer>
                        <Logo />
                        <LogoText />
                    </LogoContainer>
                    {renderPage()}
                    <DesktopCourseSetUpFooter show={currentStep === stepKeys.SURVEY}>
                        <RightContainer>
                            <Button disabled={!canSubmit} onClick={handleClickNext}>
                                {review ? 'Next' : 'Submit'}
                            </Button>
                        </RightContainer>
                    </DesktopCourseSetUpFooter>
                </DesktopCourseSetUpContainer>
            </ScrollContainer>
        </StyledDesktopContainer>
    );
};

export default Desktop;

const LogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: fit-content;
`;

const DesktopCourseSetUpContainer = styled.div`
    width: 50%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 50px;
`;

const DesktopCourseSetUpFooter = styled.div`
    display: ${(props) => (props.show ? 'flex' : 'none')};
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin-top: 34px;
    margin-bottom: 4em;
`;

const StyledDesktopContainer = styled(DesktopContainer)`
    background-color: white;
    width: 100%;
    height: 100%;
`;

const RightContainer = styled.div`
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    width: 100%;
`;

const ScrollContainer = styled.div`
    margin: -20px -40px 0;
    padding-top: 40px;
    background-color: white;
    overflow: auto;
`;
